import { ButtonProps } from '@material-ui/core/Button';
import { IconButtonProps } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIcon from "@images/icons/svg/loadingFiles.svg";
import BaseButton from './BaseButton';
import {useMutation} from "@apollo/client";
import {SYNC_MY_STATS} from "../../mutation/stats";
import {SNACKBAR_TIMEOUT} from "../constants";
import {useSnackbar} from "notistack";

type PropsIn = ButtonProps & IconButtonProps & {
  collapseOnMobile?: boolean,
  collapseOnSmallDesktop?: boolean,
  onClick?: () => void,
  disabled?: boolean,
  tooltipText?: string,
  buttonSize?: 'sm' | 'md' | 'lg',
  statsSessionIds: string[],
  label?: string,
  refetchCallback?: () => void,
}

export const UpdateStatsButton = React.forwardRef((props: PropsIn, ref) => {
  const {
    collapseOnMobile,
    collapseOnSmallDesktop,
    onClick,
    disabled,
    tooltipText,
    buttonSize,
    statsSessionIds,
    label,
    refetchCallback,
  } = props;

  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [syncMyStats] = useMutation(SYNC_MY_STATS, {
    onCompleted: () => {
      enqueueSnackbar(
        t('stats.dialog.statsSyncQueued', 'stats successfully queued to sync'),
        {
          variant: 'success',
          autoHideDuration: SNACKBAR_TIMEOUT,
        },
      );
      setTimeout(() => refetchCallback ? refetchCallback() : window.location.reload(), 500);
    },
  });

  const clickCallback: (ids: string[]) => void = onClick ?? ((ids) => {
    ids.forEach( item => {
      syncMyStats({
        variables: { statsSessionId: item },
      });
    })
  });

  return (
    <BaseButton
      startIcon={<LoadingIcon />}
      onClick={() => clickCallback(statsSessionIds)}
      disabled={disabled}
      tooltipText={tooltipText}
      collapseOnMobile={collapseOnMobile}
      collapseOnSmallDesktop={collapseOnSmallDesktop}
      buttonSize={buttonSize || 'md'}
>
  {' '}
      {label ? label : t('stats.labels.update', 'update')}
  {' '}
  </BaseButton>
);
});
